/**
 * Created by MinhQuan on 1/3/2017.
 */
angular.module('arctic.tariff.about', ['common.helper', 'pascalprecht.translate', 'taric.model.about'])
    .controller('AboutController', function (AboutModel, CONSTANTS) {
        var aboutCtrl = this;
        aboutCtrl.init = function(){
            AboutModel.getMetadata().then(function(result){
                aboutCtrl.version = result.version;
            }, function(error){
                //Do nothing if we can not load the version
            });
        };
    });



// WEBPACK FOOTER //
// ./app/about/about.js